import { ClockInGeoMode } from '@sdk/authentication/types';
import { TimeOffType } from '@sdk/timeOffs/types/TimeOffType';

export type TimeClockGeofencingModesOption = {
  name: ClockInGeoMode;
  label: 'string';
  value: boolean;
  disabled: boolean;
};

export enum TabType {
  preferences = 'preferences',
  notifications = 'notifications',
  companySettings = 'companySettings',
  schedule = 'schedule',
  timeBlocks = 'timeBlocks',
  timeClock = 'timeClock',
  laborCost = 'laborCost',
  timeOff = 'timeOff',
  integrations = 'integrations',
}

export type NavigationTabType = { value: TabType; label: string };
export type NavigationTabsType = NavigationTabType[];
export type ChangeTab = (tabData: { tab: NavigationTabType }) => void;

export type GoogleCalendarUtilsType = {
  openGoogleCalendarModal: () => Promise<string>;
  authenticateGoogleCalendar: (prop: string) => Promise<void>;
};
export type VisibilitySchedulesOptionType = {
  label: string;
  value: VisibilitySchedulesOptions;
};
export enum VisibilitySchedulesOptions {
  accessPositionsEnabled = 'accessPositionsEnabled',
  accessPositionsDisabled = 'accessPositionsDisabled',
  accessPositionsEnabledLocationsEnabled = 'accessPositionsEnabledLocationsEnabled',
  accessPositionsEnabledLocationsDisabled = 'accessPositionsEnabledLocationsDisabled',
  accessPositionsDisabledLocationsEnabled = 'accessPositionsDisabledLocationsEnabled',
  accessPositionsDisabledLocationsDisabled = 'accessPositionsDisabledLocationsDisabled',
}

export enum WebNotificationType {
  newsfeedNotifications = 'newsfeedNotifications',
  notifications = 'notifications',
}

export type ClientSettingsType = {
  [WebNotificationType.newsfeedNotifications]?: boolean;
  [WebNotificationType.notifications]?: boolean;
  didPresentNotificationQuestion?: boolean;
};

export type SetClientSettings = (settings: Partial<ClientSettingsType>) => void;
export type SetTimeOffTypes = (timeOffTypes: TimeOffType[]) => void;

export enum PromiseType {
  userSettings = 'userSettings',
  userOrgSettings = 'userOrgSettings',
  labor = 'labor',
  timeOffTypes = 'timeOffTypes',
  timeBlocks = 'timeBlocks',
  clientFlags = 'clientFlags',
}

export type PromisesConfigType = {
  [prop in PromiseType]?: { promiseIndex: number; onSuccess: (props: boolean) => void };
};
